export default {
    name: 'TreeNodeIcon',
    props: {
        tree: Object,
        node: Object
    },
    render(){
        return this.tree.$scopedSlots.icon({node:this.node})
    }
}